(function () {
  function renderGridSlider() {
    Alpine.data("kfBundlesGridSlider", (sectionId, blockCount) => ({
      swipers: {},
      sectionId: sectionId,
      blockCount: blockCount || 0,
      isMobile: window.innerWidth < 1024,

      init() {
        this.initializeSwipers();

        // Re-initialize on resize if crossing mobile/desktop boundary
        let wasMobile = this.isMobile;
        window.addEventListener("resize", () => {
          this.isMobile = window.innerWidth < 1024;
          if (wasMobile !== this.isMobile) {
            wasMobile = this.isMobile;
            this.destroySwipers();
            this.initializeSwipers();
          }
        });

        // Re-initialize when tabs change
        this.$watch("activeTab", () => {
          this.$nextTick(() => {
            this.initializeSwipers();
          });
        });
      },

      initializeSwipers() {
        if (!this.isMobile) return;

        const sectionEl = document.getElementById(this.sectionId);
        if (!sectionEl) return;

        // Find all swiper containers in this section
        const swiperContainers = sectionEl.querySelectorAll("[data-swiper-container]");

        swiperContainers.forEach((container) => {
          const swiperId = container.dataset.swiperContainer;

          // Skip if already initialized
          if (this.swipers[swiperId]) return;

          // Only initialize if container is visible
          if (container.offsetParent === null) return;

          const swiperEl = container.querySelector(".swiper");
          if (!swiperEl) return;

          // Initialize Swiper
          this.swipers[swiperId] = new Swiper(swiperEl, {
            slidesPerView: 1.3,
            spaceBetween: 10,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
            breakpoints: {
              580: {
                slidesPerView: 2.3,
              },
              1024: {
                enabled: false,
              },
            },
          });
        });
      },

      destroySwipers() {
        Object.values(this.swipers).forEach((swiper) => {
          if (swiper && swiper.destroy) {
            swiper.destroy(true, true);
          }
        });
        this.swipers = {};
      },
    }));
  }

  // Wait for Alpine to be ready
  if (window.Alpine) {
    renderGridSlider();
  } else {
    document.addEventListener("alpine:init", renderGridSlider);
  }
})();
